import { Input, InputProps } from 'antd';
import { ChangeEvent, useState, useEffect } from 'react';

type Props = Omit<InputProps, 'value'> & {
  onlyNumber?: boolean;
  value?: string;
};

const isText = /[a-z]|[A-Z]/g;
const isNumber = /\d+/g;

const InputText: React.FC<Props> = ({ onlyNumber, ...props }) => {
  const [value, setValue] = useState('');

  useEffect(() => {
    setValue(props.value ?? '');
  }, [props.value]);

  function handleChange({ target, ...event }: ChangeEvent<HTMLInputElement>) {
    const nextValue = target.value.replaceAll(
      onlyNumber ? isText : isNumber,
      '',
    );

    setValue(nextValue);

    if (props.onChange) {
      props.onChange({ ...event, target: { ...target, value: nextValue } });
    }
  }

  return <Input {...props} value={value} onChange={handleChange} />;
};

export default InputText;
